import { StyleSheet, Text, View } from 'react-native';
import { mdiLogout, mdiQrcodeScan } from '@mdi/js';
import React, { useState } from 'react';
import HeaderButton from './HeaderButton';
import LogoutModal from '../modal/LogoutModal';
import { useNavigate } from 'react-router-dom';
import { IThemeContext, useThemeContext } from '../../contexts';
import { getResponsivePadding, getResponsiveFontSize } from '../../helpers/utils';

type HeaderProps = {
  title: string;
  leftButton?: JSX.Element;
  rightButton?: JSX.Element;
};

/**
 * Header component with responsive design
 *
 * @param {HeaderProps} { title, leftButton, rightButton }
 * @return {React.FC}
 */
const Header: React.FC<HeaderProps> = ({ title, leftButton, rightButton }) => {
  const navigate = useNavigate();
  const { theme } = useThemeContext();
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
  const styles = createHeaderStyles(theme);

  const defaultRightButton = (
    <>
      <HeaderButton
        hidden={true}
        icon={mdiQrcodeScan}
        ariaLabel="QR Scanner"
        onPress={() => navigate('/scanner')}></HeaderButton>
      <HeaderButton
        icon={mdiLogout}
        ariaLabel="Logout"
        onPress={() => setShowLogoutModal(true)}></HeaderButton>
    </>
  );

  return (
    <>
      <View style={styles.header}>
        <View style={styles.headerLeftStyle}>{leftButton && leftButton}</View>
        <Text style={styles.headerTextStyle}>{title}</Text>
        <View style={styles.headerRightStyle}>
          {rightButton ? rightButton : defaultRightButton}
        </View>
      </View>
      <LogoutModal modalVisible={showLogoutModal} setModalVisible={setShowLogoutModal} />
    </>
  );
};

export default Header;

const createHeaderStyles = (theme: IThemeContext['theme']) => {
  return StyleSheet.create({
    header: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      height: 60,
      paddingLeft: getResponsivePadding(8, 12, 16),
      paddingRight: getResponsivePadding(8, 12, 16),
      backgroundColor: theme.layoutBackground,
      borderBottomWidth: 1,
      borderBottomColor: '#eee'
    },
    headerTextStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      color: theme.primary,
      fontSize: getResponsiveFontSize(18, 20, 22),
      fontWeight: 700,
      textAlign: 'center',
      paddingHorizontal: getResponsivePadding(8, 12, 16)
    },
    headerLeftStyle: {
      width: getResponsivePadding(48, 56, 64),
      justifyContent: 'flex-start'
    },
    headerRightStyle: {
      flexDirection: 'row',
      width: getResponsivePadding(48, 56, 64),
      justifyContent: 'flex-end'
    }
  });
};
